import React from 'react'

import styled from "styled-components"

import countries from "../../../assets/countries.jpg"

const Countries = () => {
  return (
    <StyledCountries src={countries} alt="countries" />
  )
}

export default Countries

const StyledCountries = styled.img`
    width: 100%;
    height: auto;
    margin: 1rem 0 7rem 0;
`